import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	titleText: {
		textTransform: "uppercase"
	}
})

export default useStyles
